module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Inkorg":"Inbox","Sök kandidater":"Search candidates","Skriv ett meddelande till kandidaten":"Write a message to the candidate","Skicka":"Send"},"sv":{"Inkorg":"Inkorg","Sök kandidater":"Sök kandidater","Skriv ett meddelande till kandidaten":"Skriv ett meddelande till kandidaten","Skicka":"Skicka"}}')
  delete Component.options._Ctor
}
